module.exports = __webpack_public_path__ + "static/Privacy-statement-4f5b561e67ac2f178ba41b9994a90235.pdf";